"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_LINK_LENGTH = void 0;
exports.MAX_LINK_LENGTH = 500;
//# sourceMappingURL=max-link-length.js.map